export default __webpack_public_path__ + "static/media/formula1.680306dd.png";